// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1SseJ","selects":"Documents_selects__2Ot8g"};